import { HttpOptions } from '../interfaces/HttpOptions';
import { HttpParams } from '../interfaces/HttpParams';

export const createHttpOptions = (
  httpParams: HttpParams,
  moduleName?: string
): HttpOptions => {
  const module = moduleName ? `/${moduleName}` : '/';
  const url = `${httpParams.baseUrl}${module}`;

  return {
    baseURL: url,
    headers: {
      'Ocp-Apim-Subscription-Key': httpParams.apiKey,
    },
  };
};
